export const CAMERA_ANGLE_ALIASES = {
  FON: ["FaceOn", "FaceOn (FO)"],
  DTL: ["DTL", "DownTheLine", "Down the Line (DTL)"],
};
